var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination-wrapper"},[_c('vs-pagination',{attrs:{"total":_vm.total},model:{value:(_vm.currentx),callback:function ($$v) {_vm.currentx=$$v},expression:"currentx"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }